import * as tslib_1 from "tslib";
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
import { throwError } from "rxjs/index";
import { catchError, map } from "rxjs/operators";
var MpHistoryService = /** @class */ (function (_super) {
    tslib_1.__extends(MpHistoryService, _super);
    function MpHistoryService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: 'makpak/mphistid'
        }) || this;
        _this.http = http;
        return _this;
    }
    MpHistoryService.prototype.loadMpHistById = function (id) {
        var res = this.http.get("" + environment.apiHost + '/makpak/mphistid?id=' + id).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
        }));
        return res;
    };
    return MpHistoryService;
}(RESTService));
export { MpHistoryService };
